import '@assets/styles/pages/fpc-status-page.scss';
import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { useContractorDetailQuery } from '@services/hooks/contractor360/useContractorDetailQuery';
import { SUPERVISOR_ALLOWED_CLASS } from '@config/constant';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useFPCDetailsQuery } from '@services/hooks/site-leads';
import { FpcDetailsSection } from '@components/contractor360/components/fpcDetails/fcpDEtailsSection';
import { FCCDetailsSection } from '@components/contractor360/components/fccCheck/fccCheckDetails';
import { useSetMainHeader } from '@hooks/useSetMainHeader';
import { useIsImpersonationLoginUser } from '../../../../authGuard/hooks/useIsImpersonationLoginUser';

export const FpcStatus = (): ReactElement => {
	useSetMainHeader('FPC Status');
	const { state } = useLocation();
	const {
		data: contractorDetails,
		isFetching,
		error,
		refetch: contractorDetailsRefetch,
	} = useContractorDetailQuery(state?.userId, state?.path);
	const { data: fpcDetails, refetch: refetchFPCStatus } = useFPCDetailsQuery(state?.membershipno);
	const isImpersonationLoginUser = useIsImpersonationLoginUser();

	return (
		<div className="fpc-status-section">
			<Wrapper isLoaderVisible={isFetching} isError={error}>
				<>
					{contractorDetails &&
						SUPERVISOR_ALLOWED_CLASS.includes(contractorDetails.contractorclass) &&
						(contractorDetails.fpc_supervisor_c ? (
							<FpcDetailsSection
								modeType="page"
								subContractor={SUPERVISOR_ALLOWED_CLASS.includes(contractorDetails?.contractorclass)}
								fpcDetails={fpcDetails?.data ?? {}}
								membershipNo={state?.membershipno}
							/>
						) : (
							<FCCDetailsSection
								isModalOpen={!isImpersonationLoginUser}
								membershipData={{ number: state?.membershipno, name: state?.name }}
								refetchRequests={(): void => {
									refetchFPCStatus?.();
									contractorDetailsRefetch?.();
								}}
							/>
						))}
				</>
			</Wrapper>
		</div>
	);
};
